import { GzSingleSelectWebComponent } from './component/GzSingleSelectWebComponent';

export { GzSingleSelectWebComponent };
